<template>
  <div class="modal-mask">
    <div class="modal-form">
      <div class="modal-form__header">
        <p class="modal-form__name">Вход</p>
        <p class="modal-form__description">Личный кабинет</p>
      </div>
      <div class="modal-form__body">
        <div class="modal-form__input">
          <AppInput title="Логин"
                    :width="mediaBreakpoint !== 'desktop' ? '100%' : '400px'"
                    :value="authData.login"
                    required
                    :valid="validation.login"
                    @value-changed="setAuthLogin"
                    @got-focus="clearValidation('login')"
                    @keyup-enter="logIn"
          />
        </div>
        <div class="modal-form__input">
          <AppInput title="Пароль"
                    :width="mediaBreakpoint !== 'desktop' ? '100%' : '400px'"
                    :value="authData.password"
                    isPassword
                    required
                    :valid="validation.password"
                    @value-changed="setAuthPassword"
                    @got-focus="clearValidation('password')"
                    @keyup-enter="logIn"
          />
        </div>

        <div class="modal-form__button-wrap">
          <AppButton title="Вход" type="main" @click.native="logIn"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '../button/AppButton.vue'
import AppInput from '../input/AppInput.vue'

export default {
  name: 'login-form',
  components: {
    AppInput,
    AppButton
  },
  computed: {
    authData () {
      return this.$store.getters.authData
    },
    validation () {
      return this.$store.getters.authData.validation
    },
    mediaBreakpoint () {
      return this.$store.getters.getMediaBreakpoint
    }
  },
  methods: {
    setAuthLogin (value) {
      this.$store.dispatch('setAuthLogin', value)
    },
    setAuthPassword (value) {
      this.$store.dispatch('setAuthPassword', value)
    },
    logIn () {
      this.$store.dispatch('logIn')
    },
    clearValidation (input) {
      this.$store.dispatch('loginFormClearValidation', input)
    }
  }
}
</script>

<style lang="scss" scoped>

.modal-mask {
  background: $color__smoke;
  background-size: cover;
  padding-right: 20px;
  padding-left: 20px;
}

.modal-form {
  width: 100%;
  max-width: 500px;
  background-color: $color__forest-wolf;
  border-radius: 3px;
  box-shadow: 0px 4px 20px rgba(112, 140, 195, 0.25);

  &__header {
    padding: 25px 20px;
    display: flex;
    flex-flow: column;
    align-items: center;
    color: $color__brown;

    @media screen and (max-width: $tablet_start) {
      padding: 14px 20px;
    }
  }

  &__name {
    font-size: 30px;
    font-weight: bold;
    text-transform: uppercase;
  }

  &__body {
    background-color: $color_main;
    color: $font_color_main;
    padding: 35px 50px;

    @media screen and (max-width: $tablet_start) {
      padding: 30px 20px;
    }
  }

  &__input {
    margin-bottom: 20px;
  }

  &__button-wrap {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
}
</style>
